import { Table as CTable, TableContainer, Td, Th, Thead, Tr } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { useState } from 'react';
import tw from 'twin.macro';

import { formatValue } from '../../utils';

const TableTitle = styled.h2`
  ${tw`ml-4 mt-3 text-lg font-semibold`}
`;

type TableProps = {
  data: any;
  headers?: string[];
  title: string;
  labels?: Object;
};

export function Table({ data: _data, headers, title, labels }: TableProps) {
  const [data] = useState(_data || []);

  return (
    <>
      <TableTitle>{title}</TableTitle>
      <TableContainer>
        <CTable variant="unstyled">
          <>
            {headers ? (
              <Thead>
                <Tr>
                  {headers.map((header, i) => (
                    <Th key={`${header}_${i}`}>{header}</Th>
                  ))}
                </Tr>
              </Thead>
            ) : null}
          </>
          <>
            {Object.keys(data).map((header: any) => {
              return (
                <Tr className="hover:bg-yellow-100">
                  <Th>{labels ? labels[header as keyof typeof labels] : header}</Th>
                  {data[header].map((h: any, i: number) => (
                    <Td key={`${header}_${h}_${i}`}>{formatValue(header, h)}</Td>
                  ))}
                </Tr>
              );
            })}
          </>
        </CTable>
      </TableContainer>
    </>
  );
}

export default Table;
